import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { openBlueprintDialogAction } from '../../../state/actions/blueprint';
import EmptyView from './view';

export default connect(null, {
	onAdd: () => {
		triggerAnalyticsEvent('summary.empty-view.add-rule.clicked');
		return openBlueprintDialogAction();
	},
})(EmptyView);
